"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import NFTImageBalanceBadge, { type NFTImageBalanceBadgeSize, type NFTImageBalanceBadgeState, type NFTImageBalanceBadgeVariant } from "@/components/nft-image/NFTImageBalanceBadge";
import { useNftBalanceFromContext } from "@/components/nft-image/NftBalancesContext";
import { useNftBalance } from "@/hooks/useNftBalance";
interface Props {
  readonly contract: string;
  readonly tokenId: number;
  readonly height: 300 | 650 | "full";
  readonly inline?: boolean | undefined;
  readonly size?: NFTImageBalanceBadgeSize | undefined;
  readonly variant?: NFTImageBalanceBadgeVariant;
}
export default function NFTImageBalance(t0) {
  const $ = _c(28);
  const {
    contract,
    tokenId,
    height,
    inline: t1,
    size,
    variant: t2
  } = t0;
  const inline = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "default" : t2;
  const {
    connectedProfile
  } = useAuth();
  const consolidationKey = connectedProfile?.consolidation_key ?? null;
  let t3;
  if ($[0] !== consolidationKey || $[1] !== contract || $[2] !== tokenId) {
    t3 = {
      consolidationKey,
      contract,
      tokenId
    };
    $[0] = consolidationKey;
    $[1] = contract;
    $[2] = tokenId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const contextBalance = useNftBalanceFromContext(t3);
  const t4 = !contextBalance;
  let t5;
  if ($[4] !== consolidationKey || $[5] !== contract || $[6] !== t4 || $[7] !== tokenId) {
    t5 = {
      consolidationKey,
      contract,
      tokenId,
      enabled: t4
    };
    $[4] = consolidationKey;
    $[5] = contract;
    $[6] = t4;
    $[7] = tokenId;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    balance: nftBalance,
    isLoading,
    error
  } = useNftBalance(t5);
  let t6;
  if ($[9] !== contextBalance || $[10] !== error || $[11] !== isLoading || $[12] !== nftBalance) {
    t6 = contextBalance ?? {
      balance: nftBalance,
      isLoading,
      error
    };
    $[9] = contextBalance;
    $[10] = error;
    $[11] = isLoading;
    $[12] = nftBalance;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const balanceState = t6;
  let t7;
  if ($[14] !== balanceState.balance || $[15] !== height || $[16] !== inline || $[17] !== size || $[18] !== variant) {
    t7 = state => <NFTImageBalanceBadge state={state} balance={balanceState.balance} height={height} inline={inline} size={size} variant={variant} />;
    $[14] = balanceState.balance;
    $[15] = height;
    $[16] = inline;
    $[17] = size;
    $[18] = variant;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const renderBadge = t7;
  if (!connectedProfile) {
    return null;
  }
  if (balanceState.isLoading) {
    let t8;
    if ($[20] !== renderBadge) {
      t8 = renderBadge("loading");
      $[20] = renderBadge;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    return t8;
  }
  if (balanceState.error) {
    console.error("Failed to fetch NFT balance:", balanceState.error);
    let t8;
    if ($[22] !== renderBadge) {
      t8 = renderBadge("error");
      $[22] = renderBadge;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    return t8;
  }
  if (balanceState.balance > 0) {
    let t8;
    if ($[24] !== renderBadge) {
      t8 = renderBadge("seized");
      $[24] = renderBadge;
      $[25] = t8;
    } else {
      t8 = $[25];
    }
    return t8;
  }
  let t8;
  if ($[26] !== renderBadge) {
    t8 = renderBadge("unseized");
    $[26] = renderBadge;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}